module.exports = __webpack_public_path__ + "img/facilita.d68b92ab.ico";